export const burgerMenu = (menu: HTMLElement, navMenu: HTMLElement) => {
    menu.addEventListener('click', () => {
        navMenu.classList.toggle('open')
    })
}